"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWindowWidth;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _react2 = require("@emotion/react");
function useWindowWidth() {
  const theme = (0, _react2.useTheme)();
  const [windowWidth, setWidth] = (0, _react.useState)(window.innerWidth);
  (0, _react.useEffect)(() => {
    const handleResize = (0, _lodash.default)(() => {
      setWidth(window.innerWidth);
    }, 350);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    windowWidth,
    aboveMd: windowWidth > (0, _parseInt2.default)(theme.db_screen_medium, 10)
  };
}